import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';

export class Agreement extends Component {
  static propTypes = {
    common: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  componentDidMount() {
    this.props.actions.fetchGetConfiguration();
  }
  render() {
    const { fetchGetConfigurationSuccess } = this.props.common;
    if (!fetchGetConfigurationSuccess) return null;
    return (
      <div className="common-agreement">
        <div className="content">
          <h1>用户协议</h1>
          <div
            dangerouslySetInnerHTML={{
              __html: fetchGetConfigurationSuccess.RegisterProtocolContent,
            }}
          />
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    common: state.common,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Agreement);



// WEBPACK FOOTER //
// ./src/features/common/Agreement.js